import { useQuery } from '@tanstack/react-query';
import { api, AnalysisRun, AnalysisRunStats } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

interface AnalysisRunsFilter {
  status?: string;
  repository_id?: string;
  limit?: number;
  offset?: number;
  search?: string;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
}

type AnalysisRunsResponse = { runs: AnalysisRun[]; total: number; stats: AnalysisRunStats };

export const useAnalysisRuns = (filter: AnalysisRunsFilter = {}, haltPolling: boolean = false) => {
  const { user, currentOrganization } = useAuth();

  return useQuery<AnalysisRunsResponse>({
    queryKey: ['analysisRuns', filter, currentOrganization?.id],
    queryFn: () => api.getAnalysisRuns(filter),
    enabled: !!user && !!currentOrganization,
    refetchInterval: (query) => {
      if (haltPolling) return false;
      const data = query.state.data as AnalysisRunsResponse | undefined;
      if (!data?.runs) return false;

      const terminalStatuses = ['COMPLETED', 'FAILED', 'CANCELLED'];
      const hasActiveScan = data.runs.some(
        (run) => !terminalStatuses.includes(run.status.toUpperCase())
      );

      return hasActiveScan ? 3000 : false;
    },
  });
};
